import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "order-items__image" };
const _hoisted_2 = ["src"];
const _hoisted_3 = { class: "order-items__title" };
const _hoisted_4 = { class: "order-items__params" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { class: "order-items__money" };
const _hoisted_7 = { class: "order-items__quantity" };
const _hoisted_8 = { class: "order-items__quantity-holder" };
const _hoisted_9 = { class: "order-items__unit" };
const _hoisted_10 = { class: "order-items__money" };
const _hoisted_11 = { class: "order-items__actions" };
const _hoisted_12 = ["title"];
import { onMounted, ref, watch } from 'vue';
import ArticleQuantityInput from "./ArticleQuantityInput.vue";
import Price from "./Price.vue";
import productUtils from '../services/ProductUtils';
import ArticleParametersForm from "./ArticleParametersForm.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CartItemRow',
    props: {
        item: {},
        taxIncluded: { type: Boolean }
    },
    emits: [
        'item-quantity-change',
        'item-remove',
        'item-params-change'
    ],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const quantityConfig = ref(null);
        const image = ref(null);
        const hasParameters = ref(false);
        const showParametersForm = ref(false);
        onMounted(() => {
            image.value = productUtils.createFirstImage(props.item.variant);
            onItemQuantityChange();
            onItemParamsChange();
        });
        function onQuantityChange(quantity) {
            if (props.item.quantity === quantity.quantity && props.item.portions === quantity.portions) {
                return;
            }
            emit('item-quantity-change', props.item, quantity);
        }
        function pricingAmount(pricing) {
            return props.taxIncluded
                ? pricing.grossPriceFormatted
                : pricing.netPriceFormatted;
        }
        function removeCartItem() {
            emit('item-remove', props.item);
        }
        watch(() => props.item.quantity, onItemQuantityChange);
        watch(() => props.item.portions, onItemQuantityChange);
        function onItemQuantityChange() {
            const orderingUnit = props.item.variant.orderingUnits
                .find(ou => ou.unitCode === props.item.unitCode)
                || productUtils.createOrderingUnitForCartItem(props.item);
            quantityConfig.value = productUtils.createQuantityConfig(props.item.quantity, props.item.variant, orderingUnit, props.item.portions);
        }
        watch(() => props.item.parameters, onItemParamsChange);
        function onItemParamsChange() {
            hasParameters.value = props.item.variant.parameters
                && JSON.stringify(props.item.variant.parameters) !== '{}' || false;
        }
        function onSubmitParameters(params) {
            showParametersForm.value = false;
            emit('item-params-change', props.item, params);
        }
        function onCancelParameters() {
            showParametersForm.value = false;
        }
        function hasItemParameters() {
            return props.item.parameters && props.item.parameters.length > 0;
        }
        return (_ctx, _cache) => {
            const _component_icon = _resolveComponent("icon");
            return (_openBlock(), _createElementBlock("tr", null, [
                _createElementVNode("td", null, _toDisplayString(__props.item.variant.sku), 1),
                _cache[3] || (_cache[3] = _createTextVNode()),
                _createElementVNode("td", _hoisted_1, [
                    (image.value)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: image.value.url,
                            alt: ""
                        }, null, 8, _hoisted_2))
                        : _createCommentVNode("", true)
                ]),
                _cache[4] || (_cache[4] = _createTextVNode()),
                _createElementVNode("td", _hoisted_3, _toDisplayString(__props.item.title), 1),
                _cache[5] || (_cache[5] = _createTextVNode()),
                _createElementVNode("td", _hoisted_4, [
                    (_ctx.$isGranted('ROLE_PERM_ORDERS_CREATE') && hasParameters.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                            _createElementVNode("a", {
                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (showParametersForm.value = true), ["prevent"])),
                                href: ""
                            }, [
                                _createVNode(_component_icon, {
                                    name: "comment",
                                    "icon-style": hasItemParameters() ? 'solid' : 'regular'
                                }, null, 8, ["icon-style"])
                            ]),
                            _cache[1] || (_cache[1] = _createTextVNode()),
                            (showParametersForm.value)
                                ? (_openBlock(), _createBlock(ArticleParametersForm, {
                                    key: 0,
                                    variant: __props.item.variant,
                                    params: __props.item.parameters,
                                    onSubmit: onSubmitParameters,
                                    onCancel: onCancelParameters
                                }, null, 8, ["variant", "params"]))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _cache[6] || (_cache[6] = _createTextVNode()),
                _createElementVNode("td", _hoisted_6, [
                    _createVNode(Price, {
                        amount: pricingAmount(__props.item.unitPricing)
                    }, null, 8, ["amount"])
                ]),
                _cache[7] || (_cache[7] = _createTextVNode()),
                _createElementVNode("td", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        (quantityConfig.value)
                            ? (_openBlock(), _createBlock(ArticleQuantityInput, {
                                key: 0,
                                ref: "article-quantity-input",
                                config: quantityConfig.value,
                                available: true,
                                "reset-on-cart-item-added": false,
                                "reset-portions-on-close": false,
                                "quantity-is-reserved": true,
                                sku: __props.item.sku,
                                unitCode: __props.item.unitCode,
                                "display-portions": "left",
                                onChange: onQuantityChange
                            }, null, 8, ["config", "sku", "unitCode"]))
                            : _createCommentVNode("", true),
                        _cache[2] || (_cache[2] = _createTextVNode()),
                        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$unit(__props.item)), 1)
                    ])
                ]),
                _cache[8] || (_cache[8] = _createTextVNode()),
                _createElementVNode("td", _hoisted_10, [
                    _createVNode(Price, {
                        amount: pricingAmount(__props.item.itemPricing)
                    }, null, 8, ["amount"])
                ]),
                _cache[9] || (_cache[9] = _createTextVNode()),
                _createElementVNode("td", _hoisted_11, [
                    _createElementVNode("a", {
                        onClick: _withModifiers(removeCartItem, ["prevent"]),
                        title: _ctx.$t('cart.remove_item'),
                        class: "order-items__remove",
                        href: ""
                    }, [
                        _createVNode(_component_icon, {
                            name: "trash-alt",
                            "icon-style": "light"
                        })
                    ], 8, _hoisted_12)
                ])
            ]));
        };
    }
});
